'use es6';

import { connect } from 'react-redux';
import { consentToProcess } from '../../gdpr/actions/visitorConsentsToProcess';
import { closeConsentToProcess } from '../../gdpr/actions/visitorClosesConsentToProcess';
import { dismissConsentToProcessError } from '../../gdpr/actions/visitorDismissesConsentToProcessError';
import { getConsentToProcessMessage } from '../../gdpr/selectors/getConsentToProcessMessage';
import { getShowGdprConsentToProcess } from '../../gdpr/selectors/getShowGdprConsentToProcess';
import ProcessConsentPrompt from '../components/ProcessConsentPrompt';
import { trackInteraction } from '../../usage-tracking/actions/trackInteraction';
import { getColoring } from '../../selectors/widgetDataSelectors/getColoring';
import { getConsentToProcessError } from '../../gdpr/selectors/getConsentToProcessError';
const mapStateToProps = state => {
  return {
    consentToProcessMessage: getConsentToProcessMessage(state),
    showGdprConsentToProcessButton: getShowGdprConsentToProcess(state),
    coloring: getColoring(state),
    consentToProcessError: getConsentToProcessError(state)
  };
};
const mapDispatchToProps = {
  consentToProcess,
  closeConsentToProcess,
  dismissConsentToProcessError,
  trackInteraction
};
export default connect(mapStateToProps, mapDispatchToProps)(ProcessConsentPrompt);